/**
 * Header scroll behavior and mobile menu functionality
 */
document.addEventListener('DOMContentLoaded', function () {
    // Header scroll behavior
    const header = document.querySelector('header');
    let lastScrollTop = 0;

    // window.addEventListener('scroll', function () {
    //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //     // If scrolling down and past a threshold (e.g., 100px), hide the header
    //     if (scrollTop > lastScrollTop && scrollTop > 100) {
    //         header.classList.add('header-hidden');
    //     }
    //     // If scrolling up, show the header
    //     else if (scrollTop < lastScrollTop) {
    //         header.classList.remove('header-hidden');
    //     }

    //     lastScrollTop = scrollTop;
    // });

    // Mobile menu functionality
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenuClose = document.querySelector('.mobile-menu-close');
    const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
    const mobileMenuContainer = document.querySelector('.mobile-menu-container');
    const body = document.body;
	const mobileMenuTrigger = document.querySelector('#menu_trigger');
	const mobileMenuTarget = document.querySelector('.nav-links');

	if (mobileMenuTrigger && mobileMenuTarget) {
		mobileMenuTrigger.addEventListener('click', () => {
			mobileMenuTarget.classList.toggle('mobile-menu-open');
		});

		document.addEventListener('click', (event) => {
			if (!mobileMenuTarget.contains(event.target) &&
				!mobileMenuTrigger.contains(event.target)) {
				mobileMenuTarget.classList.remove('mobile-menu-open');
			}
		});

		window.addEventListener('resize', () => {
			if (window.innerWidth >= 992) {
				mobileMenuTarget.classList.remove('mobile-menu-open');
			}
		});
	}

    // Function to open mobile menu
    function openMobileMenu() {
        if (mobileMenuOverlay && mobileMenuContainer) {
            mobileMenuOverlay.classList.add('active');
            mobileMenuContainer.classList.add('active');
            body.classList.add('mobile-menu-open');
        }
    }

    // Function to close mobile menu
    function closeMobileMenu() {
        if (mobileMenuOverlay && mobileMenuContainer) {
            mobileMenuOverlay.classList.remove('active');
            mobileMenuContainer.classList.remove('active');
            body.classList.remove('mobile-menu-open');
        }
    }

    // Toggle mobile menu
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function (e) {
            e.preventDefault();
            openMobileMenu();
        });
    }

    // Close mobile menu
    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileMenu();
        });
    }

    // Close mobile menu when clicking outside the menu container
    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener('click', function (e) {
            if (e.target === mobileMenuOverlay) {
                closeMobileMenu();
            }
        });
    }

    // Close mobile menu when pressing Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenuOverlay && mobileMenuOverlay.classList.contains('active')) {
            closeMobileMenu();
        }
    });

    // Close mobile menu when clicking on menu links
    const mobileMenuLinks = document.querySelectorAll('.mobile-menu-links a');
    if (mobileMenuLinks.length > 0) {
        mobileMenuLinks.forEach(function (link) {
            link.addEventListener('click', function () {
                setTimeout(closeMobileMenu, 300);
            });
        });
    }
});
